import React from 'react'
import './DiscontinuationBanner.scss'

const DiscontinuationBanner = () => {
  return (
    <div className="DiscontinuationBanner">
      <div className="discontinuation-banner-container">
        <span className="discontinuation-banner-text">
          boon.tv will be closing on January 31, 2026
        </span>
        <div className="discontinuation-banner-right">
          <a
            href="https://cocoach.com/boon-tv-closing-down"
            target="_blank"
            className="button primary small light"
          >
            Read more
          </a>
        </div>
      </div>
    </div>
  )
}

export default DiscontinuationBanner
